module.exports = new __parcel__URL__("Guest-Avatar.ebdf69f1.svg").toString();